<template>
  <div v-loading="loading">
    <div class="tips">温馨提示：本页面信息仅适合于商品或服务宣传使用，商品或服务的实际内容请与提供方确认。</div>
    <QS-h3-title title="车源信息详情" />
    <QS-column-box :source="details" :column="3" :list="list" separator=":">
      <template v-slot:inventory>
        {{details.inventory ? `${details.inventory}台` : '--'}}
      </template>
      <template v-slot:leaseProgrammes>
        <QS-common-table :data="details.leaseProgrammes" :columns="columns" :pagination="false" />
      </template>
      <template v-slot:additionalServices>
        <el-checkbox-group v-model="details.additionalServices" disabled>
          <el-checkbox v-for="item in specialAssetsArr" :label="item.key" :key="item.key">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-slot:picture>
        <div>
          <img v-for="(item, i) in details.picture" :src="item.url" style="width: 120px; margin-right: 10px; cursor: pointer" :key="i" @click="() => {openImgView(item.url)}" />
        </div>
      </template>
    </QS-column-box>
    <ImageView
      v-if="imgViewShow"
      :imgViewShow="imgViewShow"
      :imgList="imgViewList"
      @closeImgView="closeImgView"
    />
  </div>
</template>

<script>
import { infoManageDetail } from '@/api/carResource/index.js'
import { COLUMN_BOX_LIST, COLUMN_BOX_LIST_LESS, columns1, columns2, specialAssetsArr, LEASE_TYPE } from '../const.js'
import ImageView from '@/components/UploadCommon/components/ImageView'
import * as Sentry from '@sentry/vue'

export default {
  components: { ImageView },
  data() {
    const byLease = Number(this.$route.query.leaseType) === LEASE_TYPE.FINANCIAL
    return {
      specialAssetsArr,
      details: {
        leaseProgrammes: [],
        additionalServices: [],
        picture: [],
      },
      loading: false,
      list: byLease ? COLUMN_BOX_LIST : COLUMN_BOX_LIST_LESS,
      columns: byLease ? columns1 : columns2,
      imgViewShow: false,
      imgViewList: [],
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      const { carResourceId } = this.$route.query
      this.loading = true
      infoManageDetail({ carResourceId }).then((res) => {
        const { code, data } = res || {}
        if (code === 1) {
          try {
            data.additionalServices = JSON.parse(data.additionalServices)
          } catch (e) {
            data.additionalServices = []
            Sentry.captureException(e)
          }
          data.picture = this.getURL({
            data: data.picture,
            needName: true,
          })
          data.leaseProgrammes.forEach((item, i) => {
            item.index = i + 1
          })
          this.details = data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openImgView(img) {
      this.imgViewList = [img]
      this.imgViewShow = true
    },
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
  },
}
</script>
<style lang='less' scoped>
.tips {
  color: #f6a804;
  margin-bottom: 15px;
  padding: 0;
}
.basic-list {
  margin-top: 0;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  border-color: #fff;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #276BEC;
  border-color: #276BEC;
}
::v-deep .el-checkbox__input.is-disabled+span.el-checkbox__label {
  color: #303133;
}
</style>
